
export class Whisky
{
    key: string = "";
    name: string = "";
    distillery: string = "";
    region: string = "";
    rating: string = "";
    shelves: string[] = [ "" ];
    bottler : string = "";
    image: string = "";
    URL: string = "";
    SMWS: string = "";
    timestamp: number;

    isHeader: boolean = false;
}




// WEBPACK FOOTER //
// ./src/data/whisky.ts